import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'WatchVideos';

const WatchVideosApi: any = baseApi(endpoint);

export default WatchVideosApi;